/* eslint-disable no-use-before-define */
/* eslint-disable prettier/prettier */
/**
 * DO NOT EDIT THIS FILE MANUALLY
 * Generated by `Opus::GeneratedFileVerifier::Generators::TsTypes::ConversationsAPITsTypeGenerator`
 * If this file is out-of-sync or causing builds to fail, try running `pay bazel:run //tools/javascript:gen_ts_types`
 */
export type Audience =
  | 'connect'
  | 'dot_com'
  | 'end_user'
  | 'express'
  | 'internal'
  | 'link'
  | 'onboarding'
  | 'stripe'
  | 'test';

export const Audience_values = [
  'stripe',
  'dot_com',
  'connect',
  'express',
  'link',
  'end_user',
  'onboarding',
  'test',
  'internal',
] as const;

export type ConversationsApiCreateConversationEndpointRequest = {
  audience: Audience,
  entry_point: SupportEntryPointEntryPoint,
  trigger_point?: SupportTriggerPointTriggerPoint,
  locale: string,
  refcode?: string,
  forest_version?: string,
  starting_guide?: string,
  preselected_topic?:
    | 'api_integration'
    | 'apms'
    | 'atlas'
    | 'billing'
    | 'capital'
    | 'change_account_info'
    | 'charge_lookup'
    | 'connect'
    | 'corporate_card'
    | 'declines'
    | 'disputes'
    | 'embedded'
    | 'financial_reports'
    | 'getting_started'
    | 'issuing'
    | 'login_issues'
    | 'migrations'
    | 'other'
    | 'payment_apis'
    | 'payouts'
    | 'pci'
    | 'pricing'
    | 'privacy_request'
    | 'radar'
    | 'refunds'
    | 'sigma'
    | 'stripe_apps'
    | 'tax'
    | 'terminal'
    | 'third_party_integrations'
    | 'treasury'
    | 'verification',
  page_context?: Record<string, string>,
};

export type ConversationsApiCreateConversationEndpointResponseError = {
  type: 'error',
  error: string,
};

export type ConversationsApiCreateConversationEndpointResponseSuccess = {
  type: 'success',
  conversation: ConversationsApiDataConversation,
};

export type ConversationsApiDataConversation = {
  id: string,
  audience: string,
  entry_point: SupportEntryPointEntryPoint,
  trigger_point?: SupportTriggerPointTriggerPoint,
  locale: string,
  owner_id?: string,
  messages: Array<ConversationsApiDataMessage>,
  participants: Array<ConversationsApiDataParticipant>,
};

export type ConversationsApiDataConversationOverview = {
  id: string,
  is_active: boolean,
  last_updated_at: number,
};

export type ConversationsApiDataConversationStatus = 'active' | 'inactive';

export const ConversationsApiDataConversationStatus_values = [
  'active',
  'inactive',
] as const;

export type ConversationsApiDataDynamic = 'active' | 'done' | 'if_latest';

export const ConversationsApiDataDynamic_values = [
  'if_latest',
  'active',
  'done',
] as const;

export type ConversationsApiDataMessage = {
  id: string,
  participant_id: string,
  participant_type: string,
  parts: Array<ConversationsApiDataMessagePart>,
  created: number,
  dynamic?: ConversationsApiDataDynamic,
  creator_part_id?: string,
  in_response_to_id?: string,
  disable_input: boolean,
  page_context?: Record<string, string>,
  thumbs_feedback?: 'none' | 'thumbs_down' | 'thumbs_up',
};

export type ConversationsApiDataMessagePartAiResponse = {
  type: 'ai_response',
  id: number,
  content: ConversationsApiDataMessagePartContentAiResponsePartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartButtons = {
  type: 'buttons',
  id: number,
  content: ConversationsApiDataMessagePartContentButtonsPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartChannelMenu = {
  type: 'channel_menu',
  id: number,
  content: ConversationsApiDataMessagePartContentChannelMenuPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartContentAiResponsePartContent = {
  text: string,
  rendering?: string,
  component_name?: string,
};

export type ConversationsApiDataMessagePartContentButtonsPartContent = {
  text: string,
  buttons: Array<ConversationsApiDataMessagePartContentButtonsPartContentButtonItem>,
};

export type ConversationsApiDataMessagePartContentButtonsPartContentButtonItem = {
  title: string,
  url: string,
};

export type ConversationsApiDataMessagePartContentChannelMenuPartContent = {
  text: string,
  rendering?: string,
};

export type ConversationsApiDataMessagePartContentOptionsPartContent = {
  text: string,
  options: Array<ConversationsApiDataMessagePartContentOptionsPartContentOptionItem>,
  style?: string,
};

export type ConversationsApiDataMessagePartContentOptionsPartContentOptionItem = {
  id: string,
  text: string,
};

export type ConversationsApiDataMessagePartContentSelectedOptionPartContent = {
  id: string,
  text: string,
};

export type ConversationsApiDataMessagePartContentShowInlineDataPartContent = {
  text: string,
  inline_data_name: string,
  rendering: string,
  inline_data_style?: string,
};

export type ConversationsApiDataMessagePartContentTextPartContent = {
  text: string,
};

export type ConversationsApiDataMessagePartContentThumbsFeedbackPartContent = {
  text: string,
  feedback_value: string,
  message_id: string,
};

export type ConversationsApiDataMessagePartOptions = {
  type: 'options',
  id: number,
  content: ConversationsApiDataMessagePartContentOptionsPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartSelectedOption = {
  type: 'selected_option',
  id: number,
  content: ConversationsApiDataMessagePartContentSelectedOptionPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartShowInlineData = {
  type: 'show_inline_data',
  id: number,
  content: ConversationsApiDataMessagePartContentShowInlineDataPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartText = {
  type: 'text',
  id: number,
  content: ConversationsApiDataMessagePartContentTextPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataMessagePartThumbsFeedback = {
  type: 'thumbs_feedback',
  id: number,
  content: ConversationsApiDataMessagePartContentThumbsFeedbackPartContent,
  dynamic?: ConversationsApiDataDynamic,
};

export type ConversationsApiDataParticipant = {
  id: string,
  merchant_id?: string,
  type:
    | 'assistant'
    | 'human_agent'
    | 'system'
    | 'user',
  display_name?: string,
};

export type ConversationsApiDeleteConversationEndpointResponseError = {
  type: 'error',
  error: string,
};

export type ConversationsApiDeleteConversationEndpointResponseSuccess = {
  type: 'success',
  id: string,
  deleted: boolean,
};

export type ConversationsApiListConversationsEndpointRequest = {
  audience: Audience,
  entry_point: SupportEntryPointEntryPoint,
  trigger_point?: SupportTriggerPointTriggerPoint,
  status?: ConversationsApiDataConversationStatus,
  limit?: number,
};

export type ConversationsApiListConversationsEndpointResponseError = {
  type: 'error',
  error: string,
};

export type ConversationsApiListConversationsEndpointResponseSuccess = {
  type: 'success',
  conversations: Array<ConversationsApiDataConversationOverview>,
};

export type ConversationsApiPollConversationEndpointResponseError = {
  type: 'error',
  error: string,
};

export type ConversationsApiPollConversationEndpointResponseSuccess = {
  type: 'success',
  messages: Array<ConversationsApiDataMessage>,
};

export type ConversationsApiRetrieveConversationEndpointResponseError = {
  type: 'error',
  error: string,
};

export type ConversationsApiRetrieveConversationEndpointResponseSuccess = {
  type: 'success',
  conversation: ConversationsApiDataConversation,
};

export type ConversationsApiSendMessageEndpointRequest = {
  id?: string,
  participant_id: string,
  participant_type: string,
  parts: Array<ConversationsApiDataMessagePart>,
  creator_part_id?: string,
  page_context?: Record<string, string>,
};

export type ConversationsApiSendMessageEndpointResponseError = {
  type: 'error',
  error: string,
};

export type ConversationsApiSendMessageEndpointResponseSuccess = {
  type: 'success',
  conversation: ConversationsApiDataConversation,
};

export type SupportEntryPointEntryPoint =
  | 'dashboard'
  | 'dashboard_feedback'
  | 'dot_com'
  | 'dot_com_embedded_csf'
  | 'embedded_connect_support_site'
  | 'end_user_support_site'
  | 'express_dashboard'
  | 'express_support_site'
  | 'front'
  | 'inbound_call'
  | 'inbound_email'
  | 'internal_admin'
  | 'issuing_support'
  | 'link_support_site'
  | 'mobile_android'
  | 'mobile_ios'
  | 'mobile_link_android'
  | 'mobile_link_ios'
  | 'native_mobile_ios'
  | 'onboarding'
  | 'platform_support_site'
  | 'react_native_mobile_android'
  | 'react_native_mobile_ios'
  | 'slack'
  | 'support_site';

export const SupportEntryPointEntryPoint_values = [
  'support_site',
  'dot_com',
  'dot_com_embedded_csf',
  'dashboard',
  'mobile_ios',
  'native_mobile_ios',
  'mobile_android',
  'react_native_mobile_ios',
  'react_native_mobile_android',
  'mobile_link_ios',
  'mobile_link_android',
  'express_dashboard',
  'express_support_site',
  'link_support_site',
  'end_user_support_site',
  'embedded_connect_support_site',
  'platform_support_site',
  'dashboard_feedback',
  'front',
  'inbound_call',
  'inbound_email',
  'slack',
  'onboarding',
  'issuing_support',
  'internal_admin',
] as const;

export type SupportTriggerPointTriggerPoint =
  | 'account_status_home_call_to_action'
  | 'account_status_task_details_call_to_action'
  | 'assistant_drawer_internal'
  | 'assistant_onboarding'
  | 'assistant_search_result_direct'
  | 'assistant_search_result_suggested_query'
  | 'dashboard_checkout_studio_builder'
  | 'dashboard_checkout_studio_builder_greeting_message'
  | 'dashboard_checkout_studio_inspect'
  | 'dashboard_help_icon'
  | 'dashboard_help_menu_contact_support'
  | 'dashboard_mobile_ios_app_get_help'
  | 'dashboard_mobile_ios_assistant'
  | 'dashboard_search_ai'
  | 'dashboard_support_center_case_detail_page'
  | 'dashboard_support_center_home'
  | 'dot_com_chat_button'
  | 'dot_com_chat_button_with_llm'
  | 'dot_com_console'
  | 'dot_com_embedded_csf'
  | 'dot_com_embedded_csf_self_serve'
  | 'internal_admin'
  | 'link_mobile_get_support'
  | 'payments_analytics'
  | 'question_helpfulness_sorry_message'
  | 'react_native_mobile_get_help'
  | 'support_site_contact_support_link'
  | 'support_site_contact_url'
  | 'support_site_contact_us_link'
  | 'support_site_content'
  | 'support_site_i_cant_sign_in'
  | 'unspecified';

export const SupportTriggerPointTriggerPoint_values = [
  'dashboard_help_menu_contact_support',
  'dashboard_help_icon',
  'assistant_search_result_direct',
  'assistant_drawer_internal',
  'dashboard_support_center_home',
  'react_native_mobile_get_help',
  'dashboard_mobile_ios_app_get_help',
  'link_mobile_get_support',
  'dashboard_mobile_ios_assistant',
  'support_site_contact_url',
  'support_site_contact_support_link',
  'support_site_i_cant_sign_in',
  'question_helpfulness_sorry_message',
  'support_site_content',
  'dot_com_chat_button',
  'dot_com_embedded_csf',
  'dot_com_embedded_csf_self_serve',
  'dashboard_search_ai',
  'dashboard_checkout_studio_builder',
  'dashboard_checkout_studio_builder_greeting_message',
  'dashboard_checkout_studio_inspect',
  'payments_analytics',
  'unspecified',
  'internal_admin',
  'account_status_home_call_to_action',
  'account_status_task_details_call_to_action',
  'dot_com_chat_button_with_llm',
  'dot_com_console',
  'dashboard_support_center_case_detail_page',
  'assistant_onboarding',
  'assistant_search_result_suggested_query',
  'support_site_contact_us_link',
] as const;

export type UniversalHelpPrivateDocumentMessagePartMessagePartType =
  | 'ai_response'
  | 'buttons'
  | 'channel_menu'
  | 'options'
  | 'selected_option'
  | 'show_inline_data'
  | 'text'
  | 'thumbs_feedback';

export const UniversalHelpPrivateDocumentMessagePartMessagePartType_values = [
  'text',
  'options',
  'selected_option',
  'buttons',
  'ai_response',
  'show_inline_data',
  'channel_menu',
  'thumbs_feedback',
] as const;

export type ConversationsApiCreateConversationEndpointResponse = ConversationsApiCreateConversationEndpointResponseError | ConversationsApiCreateConversationEndpointResponseSuccess;

export type ConversationsApiDataMessagePart =
  | ConversationsApiDataMessagePartAiResponse
  | ConversationsApiDataMessagePartButtons
  | ConversationsApiDataMessagePartChannelMenu
  | ConversationsApiDataMessagePartOptions
  | ConversationsApiDataMessagePartSelectedOption
  | ConversationsApiDataMessagePartShowInlineData
  | ConversationsApiDataMessagePartText
  | ConversationsApiDataMessagePartThumbsFeedback;

export type ConversationsApiDeleteConversationEndpointResponse = ConversationsApiDeleteConversationEndpointResponseError | ConversationsApiDeleteConversationEndpointResponseSuccess;

export type ConversationsApiListConversationsEndpointResponse = ConversationsApiListConversationsEndpointResponseError | ConversationsApiListConversationsEndpointResponseSuccess;

export type ConversationsApiPollConversationEndpointResponse = ConversationsApiPollConversationEndpointResponseError | ConversationsApiPollConversationEndpointResponseSuccess;

export type ConversationsApiRetrieveConversationEndpointResponse = ConversationsApiRetrieveConversationEndpointResponseError | ConversationsApiRetrieveConversationEndpointResponseSuccess;

export type ConversationsApiSendMessageEndpointResponse = ConversationsApiSendMessageEndpointResponseError | ConversationsApiSendMessageEndpointResponseSuccess;
